import React, { useState } from 'react';
import { XIcon, BellIcon } from 'lucide-react';
interface SaveSearchModalProps {
  onSave: (name: string) => void;
  onClose: () => void;
}
export function SaveSearchModal({
  onSave,
  onClose
}: SaveSearchModalProps) {
  const [searchName, setSearchName] = useState('');
  const [enableAlerts, setEnableAlerts] = useState(true);
  const [frequency, setFrequency] = useState('daily');
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (searchName.trim()) {
      onSave(searchName);
    }
  };
  return <div className="fixed inset-0 z-50 overflow-y-auto" data-id="element-695">
      <div className="flex items-center justify-center min-h-screen px-4" data-id="element-696">
        {/* Backdrop */}
        <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" onClick={onClose} data-id="element-697"></div>
        {/* Modal */}
        <div className="relative bg-white rounded-lg max-w-md w-full shadow-xl" data-id="element-698">
          <div className="absolute top-0 right-0 pt-4 pr-4" data-id="element-699">
            <button type="button" className="text-gray-400 hover:text-gray-500" onClick={onClose} data-id="element-700">
              <XIcon size={20} data-id="element-701" />
            </button>
          </div>
          <div className="p-6" data-id="element-702">
            <div className="text-center" data-id="element-703">
              <h3 className="text-lg font-medium text-gray-900" data-id="element-704">
                Enregistrer cette recherche
              </h3>
              <p className="mt-1 text-sm text-gray-500" data-id="element-705">
                Enregistrez cette recherche pour y accéder rapidement et
                recevoir des alertes lorsque de nouveaux appels d'offres
                correspondants sont publiés.
              </p>
            </div>
            <form onSubmit={handleSubmit} className="mt-5" data-id="element-706">
              <div className="mb-4" data-id="element-707">
                <label htmlFor="search-name" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-708">
                  Nom de la recherche
                </label>
                <input type="text" id="search-name" value={searchName} onChange={e => setSearchName(e.target.value)} placeholder="Ex: Projets de construction au Sénégal" className="block w-full border-gray-300 rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500 sm:text-sm" required data-id="element-709" />
              </div>
              <div className="mb-4" data-id="element-710">
                <div className="flex items-center" data-id="element-711">
                  <input id="enable-alerts" type="checkbox" checked={enableAlerts} onChange={() => setEnableAlerts(!enableAlerts)} className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded" data-id="element-712" />
                  <label htmlFor="enable-alerts" className="ml-2 flex items-center text-sm text-gray-700" data-id="element-713">
                    <BellIcon size={16} className="mr-1 text-yellow-500" data-id="element-714" />
                    Activer les alertes par email
                  </label>
                </div>
              </div>
              {enableAlerts && <div className="mb-4 ml-6" data-id="element-715">
                  <label htmlFor="alert-frequency" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-716">
                    Fréquence des alertes
                  </label>
                  <select id="alert-frequency" value={frequency} onChange={e => setFrequency(e.target.value)} className="block w-full border-gray-300 rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500 sm:text-sm" data-id="element-717">
                    <option value="instant" data-id="element-718">Instantanée</option>
                    <option value="daily" data-id="element-719">Quotidienne</option>
                    <option value="weekly" data-id="element-720">Hebdomadaire</option>
                  </select>
                  <p className="mt-1 text-xs text-gray-500" data-id="element-721">
                    Vous recevrez un email lorsque de nouveaux appels d'offres
                    correspondant à vos critères seront publiés.
                  </p>
                </div>}
              <div className="mt-6 flex justify-end space-x-3" data-id="element-722">
                <button type="button" onClick={onClose} className="inline-flex items-center px-4 py-2 border border-gray-300 shadow-sm text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500" data-id="element-723">
                  Annuler
                </button>
                <button type="submit" className="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500" data-id="element-724">
                  Enregistrer
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>;
}